module.exports = __webpack_public_path__ + "static/media/footer-background.79c00285.webp";